import { posthog } from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://us.i.posthog.com';

let initialized = false;

export function initPosthog(): void {
  if (initialized || !POSTHOG_KEY) {
    return;
  }
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      disable_session_recording: false,
      persistence: 'localStorage+cookie',
      person_profiles: 'identified_only',
    });
    initialized = true;
  } catch (e) {
    console.warn('[posthog] init failed', e);
  }
}

export function identifyUser(userId: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  try {
    posthog.identify(userId, properties);
  } catch (_) {}
}

export function captureEvent(event: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch (_) {}
}

export function resetUser(): void {
  if (!initialized) return;
  try {
    posthog.reset();
  } catch (_) {}
}

export default posthog;
